// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import MilitaryEarningItem from "./MilitaryEarningItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MilitaryEarningLayer extends BasePopUpLayer {

	@property({ type: cc.ScrollView, displayName:'' })
	scrollView: cc.ScrollView = null;

    @property(cc.Prefab)
    itemPrefab: cc.Prefab = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initLayer();
    }

    initLayer() {
        let content = this.scrollView.content;
        let goods = this._carryData.goods;
        let counts = this._carryData.counts;
        for (let i = 0; i < goods.length; i++) {
            let itemNode = cc.instantiate(this.itemPrefab);
            content.addChild(itemNode);

            let script = itemNode.getComponent(MilitaryEarningItem);
            script.setData(goods[i], counts[i]);
        }
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }

    // update (dt) {}
}
